export const API_PREFIX = '/api'
export const COMMUNITY_API_PREFIX = '/api/community/community'
export const COMMUNITY_OPEN_GLOBAL_PREFIX = '/api/community/open/global/community'
export const COMMUNITY_SECURE_GLOBAL_PREFIX = '/api/community/secure/global/community'
export const COMMENT_API_PREFIX = '/api/comment/comments'
export const INNER_API = process.env.SIO_INNER_HOST
